// CSS específico del selector d1
import './tarokina_d1.scss';

// Módulos compartidos del plugin (usar rutas relativas desde este archivo)
import initTablero from '../../../../../public/modules/tablero/tablero.js';
import initSelector from '../../../../../public/modules/selectors/d1/d1.js';

// Debug util: silenciar logs salvo modo debug
const TKNA_DEBUG = (() => { try { return !!window.__TKNA_DEBUG; } catch (_) { return false; } })();
function debugLog() { if (TKNA_DEBUG && typeof console !== 'undefined' && console.log) { try { console.log.apply(console, arguments); } catch (_) {} } }
// Aquí irían los scripts específicos del frontend del tema Tarokina
console.log("Tarokina d1 js");

// WordPress i18n (fallback simple si no está disponible)
const { __ } = (window.wp && window.wp.i18n) ? window.wp.i18n : { __: (s) => s };

// Función debounce para limitar la frecuencia de llamadas
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Registro global de instancias y ejecución scopeada por instancia
function ensureInstanceRegistry() {
  if (!window.__tknaInstances) {
    // Fallback si Map no está disponible
    if (typeof Map === 'function') {
      window.__tknaInstances = new Map(); // key: tarotId, value: { container, cfg }
    } else {
      const store = Object.create(null);
      window.__tknaInstances = {
        _s: store,
        set: function(key, val) { this._s[String(key)] = val; return this; },
        get: function(key) { return this._s[String(key)]; },
        has: function(key) { return Object.prototype.hasOwnProperty.call(this._s, String(key)); },
        delete: function(key) { const k = String(key); if (this.has(k)) { delete this._s[k]; return true; } return false; },
        forEach: function(cb, thisArg) { for (var k in this._s) { if (Object.prototype.hasOwnProperty.call(this._s, k)) { cb.call(thisArg, this._s[k], k, this); } } }
      };
    }
  }
  return window.__tknaInstances;
}

function runModulesForInstance(inst) {
  const prev = window.tarokina;
  const themeOptions = inst?.cfg?.themeOptions || {};
  const options = inst?.cfg?.options || {};
  const spreadN = Number(inst?.cfg?.spreadN ?? themeOptions.spread_N ?? 0);
  try {
  const tkConfig = {
      tarot_theme: themeOptions,
      tarot_options: options,
      spread_N: isNaN(spreadN) ? 0 : spreadN,
  // Exponer ajax para módulos que lo usen (compatibilidad con código legacy)
  ajax_url: inst?.cfg?.ajaxUrl || (window.ajaxurl || ''),
  nonce: inst?.cfg?.ajaxNonce || '',
  // Nuevo: id de la lectura actual para diagnóstico y backend
  tarot_id: inst?.cfg?.tarotId || 0,
  };
  window.tarokina = tkConfig;
  // Adjuntar configuración scopeada al contenedor para el módulo
  try { inst.container.__tknaConfig = tkConfig; } catch (_) {}
    window.__tknaUnifiedBootstrap = true;
  } catch (e) {
    console.error('[tarokina] error creando window.tarokina', e);
  }
  try { (initTablero.default || initTablero)(inst.container); } catch (_) {}
  try { (initSelector.default || initSelector)(inst.container); } catch (_) {}
  // Restaurar el valor previo por seguridad (evitar fugas entre instancias)
  try { window.tarokina = prev; } catch (_) {}
}

// Workaround Safari: asegurar recálculo tras el primer paint/estilos aplicados
function ensureSafariLayout(container, cfg) {
  // Doble RAF para dejar que estilos/DOM se asienten y recacular después
  try {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => runModulesForInstance({ container, cfg }));
    });
  } catch (_) {}

  // Reintentar al cargar totalmente la página (recupera medidas de imágenes/fonts)
  const rerun = () => runModulesForInstance({ container, cfg });
  try { window.addEventListener('load', rerun, { once: true }); } catch (_) {}
  try {
    window.addEventListener('pageshow', (e) => {
      if (e && e.persisted) { rerun(); }
    }, { once: true });
  } catch (_) {}

  // ResizeObserver: cuando el contenedor tenga tamaño no-cero, recalcular una vez
  try {
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const rect = entry && entry.contentRect ? entry.contentRect : { width: 0, height: 0 };
          if (rect.width > 0 && rect.height > 0) {
            try { ro.disconnect(); } catch (_) {}
            runModulesForInstance({ container, cfg });
            break;
          }
        }
      });
      ro.observe(container);
    }
  } catch (_) {}

  // Fallback con pequeño timeout por si todo lo anterior falla
  try { setTimeout(() => runModulesForInstance({ container, cfg }), 60); } catch (_) {}
}

// Esperar a que la instancia esté "lista": loader oculto y sin imágenes pendientes, o timeout
function waitForInstanceReady(container, maxWait = 2000) {
  return new Promise((resolve) => {
    const start = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    const hasTime = () => {
      const now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
      return (now - start) < maxWait;
    };
    const loaderVisible = () => {
      try {
        const cand = container.querySelector('[data-role="loader"], [data-role="loader-overlay"], .tkna-loader-overlay, .tkna-loader');
        if (!cand) return false;
        const cs = window.getComputedStyle ? window.getComputedStyle(cand) : null;
        if (!cs) return false;
        const hidden = (cs.display === 'none') || (cs.visibility === 'hidden') || (parseFloat(cs.opacity || '1') < 0.05);
        return !hidden;
      } catch (_) { return false; }
    };
    const imagesPending = () => {
      try {
        const imgs = Array.from(container.querySelectorAll('img'));
        return imgs.some((img) => !img.complete);
      } catch (_) { return false; }
    };
    const tick = () => {
      try {
        if (!loaderVisible() && !imagesPending()) { resolve(); return; }
      } catch (_) { /* noop */ }
      if (!hasTime()) { resolve(); return; }
      try { requestAnimationFrame(tick); } catch (_) { setTimeout(tick, 50); }
    };
    tick();
  });
}

function resolvePreloaderElement(container, cfg) {
  if (!container) return null;
  
  // First try with tarot-specific ID (new format: tkna_preloader_83)
  const doc = (typeof document !== 'undefined') ? document : null;
  if (doc && cfg) {
    const tarotId = cfg.tarotId ?? cfg.tarot_id ?? cfg.id ?? cfg.instance_id;
    if (tarotId !== undefined && tarotId !== null && tarotId !== '') {
      const idStr = String(tarotId);
      try {
        // Try new unique ID format first
        const uniqueId = `tkna_preloader_${idStr}`;
        const uniqueEl = doc.getElementById(uniqueId);
        if (uniqueEl) {
          return uniqueEl;
        }
      } catch (_) {}
      
      // Fallback to old format with data-tarot-id attribute
      try {
        const escaped = (typeof window !== 'undefined' && window.CSS && typeof window.CSS.escape === 'function')
          ? window.CSS.escape(idStr)
          : idStr.replace(/"/g, '\\"');
        const inst = doc.querySelector(`#tkna_preloader[data-tarot-id="${escaped}"], .tkna-preloader[data-tarot-id="${escaped}"]`);
        if (inst) {
          return inst;
        }
      } catch (_) {
        try {
          const inst = doc.querySelector(`#tkna_preloader[data-tarot-id="${idStr}"], .tkna-preloader[data-tarot-id="${idStr}"]`);
          if (inst) {
            return inst;
          }
        } catch (_) {}
      }
    }
  }
  
  // Legacy support: check if container itself is the preloader
  try {
    if (typeof container.matches === 'function' && (container.matches('#tkna_preloader') || container.matches('.tkna-preloader'))) {
      return container;
    }
  } catch (_) {}
  try {
    if (typeof container.closest === 'function') {
      const fromClosest = container.closest('#tkna_preloader, .tkna-preloader');
      if (fromClosest) {
        return fromClosest;
      }
    }
  } catch (_) {}
  try {
    if (typeof container.querySelector === 'function') {
      const scoped = container.querySelector('#tkna_preloader, .tkna-preloader');
      if (scoped) {
        return scoped;
      }
    }
  } catch (_) {}
  
  // Final fallback
  if (doc) {
    try {
      const fallback = doc.querySelector('#tkna_preloader, .tkna-preloader');
      if (fallback) {
        return fallback;
      }
    } catch (_) {}
  }
  return container;
}

// Utilidad: visibilidad efectiva del loader de instancia
// (Eliminado) Helper de visibilidad del loader antiguo ya no utilizado

// Duración mínima del loader en re-tirada para sincronizar con la espera AJAX
function getRethrowLoaderDuration(tktaLoaderClass, cfg) {
  try {
    const v = String(tktaLoaderClass || '').toLowerCase();
    if (!v || v === 'disable') return 0;
  const msRaw = cfg && cfg.themeOptions ? cfg.themeOptions.tkta_loader_duration_ms : undefined;
  // Si no está configurado (undefined, null o cadena vacía), usar 2000ms por defecto
  if (msRaw === undefined || msRaw === null || msRaw === '') return 2000;
  const ms = Number(msRaw);
  if (Number.isFinite(ms) && ms >= 0) return ms; // soporta 0 explícito
    // Fallback por defecto
    return 2000;
  } catch (_) { return 2000; }
}

// Retardo inicial antes de mostrar el loader (global)
function getLoaderInitialDelay(cfg) {
  try {
    const raw = cfg && cfg.themeOptions ? cfg.themeOptions.tkta_loader_initial_delay_ms : undefined;
    if (raw === undefined || raw === null || raw === '') return 1000;
    const ms = Number(raw);
    return (Number.isFinite(ms) && ms >= 0) ? ms : 1000;
  } catch (_) { return 1000; }
}

// Asegurar/crear el loader de instancia igual que el template y añadir la clase del loader configurado
function ensureInstLoader(container, tktaLoaderClass) {
  try {
    // Si el modo de loader está desactivado, no crear nada
    if (!tktaLoaderClass || String(tktaLoaderClass).toLowerCase() === 'disable') {
      const existing = container.querySelector('[data-role="loader-bloq"]');
      return { loaderBloq: existing || null, innerLoader: existing ? existing.querySelector('[data-role="loader"]') : null };
    }
    let loaderBloq = container.querySelector('[data-role="loader-bloq"]');
    // Si no existe (pudo ser eliminado tras la primera lectura), crear uno nuevo como hermano de .spread.tablero_container
    if (!loaderBloq) {
      const spreadWrap = container.querySelector('.spread-wrap') || container;
      const spreadContainer = container.querySelector('.spread.tablero_container');
      const div = document.createElement('div');
      div.className = 'tkina-loader-bloq';
      div.setAttribute('data-role', 'loader-bloq');
      div.setAttribute('data-inst-id', container.getAttribute('data-tarot-id') || '');
      div.innerHTML = '<div class="loader_content"><h3 class="tkina-loader" data-role="loader" aria-live="polite"></h3></div>';
      // Insertar después del contenedor de spread si está; si no, al final de spread-wrap
      if (spreadContainer && spreadContainer.parentNode) {
        spreadContainer.parentNode.insertBefore(div, spreadContainer.nextSibling);
      } else {
        spreadWrap.appendChild(div);
      }
      loaderBloq = div;
    }
    // Asegurar clase del loader visual (loader1/loader2/etc.) en el elemento interno
    const innerLoader = loaderBloq.querySelector('[data-role="loader"]');
  if (innerLoader && tktaLoaderClass) {
      innerLoader.classList.add(String(tktaLoaderClass));
    }
    return { loaderBloq, innerLoader };
  } catch (_) {
    return { loaderBloq: null, innerLoader: null };
  }
}

// Bootstrap y orquestación por instancia usando datos de window.TkinaThemeData
function initTarokinaInstance(container, cfg) {
  const theme = 'tarokina';
  try {
    const tarotId = String(cfg?.tarotId ?? '');
    const themeOptions = cfg?.themeOptions || {};
    const options = cfg?.options || {};

  debugLog('[tarokina] init instance', tarotId, cfg);
  debugLog('themeOptions: ', themeOptions);
  debugLog('options: ', options);

    // Registrar instancia
    const registry = ensureInstanceRegistry();
    registry.set(tarotId, { container, cfg });

  // Ejecutar módulos scopeados a esta instancia (via window.tarokina)
  runModulesForInstance({ container, cfg });
  // Y forzar un recálculo post-paint para Safari
  ensureSafariLayout(container, cfg);

  // Nota: ya no se vincula el loader de instancia al overlay global en el flujo de re‑tirada

    // Funcionalidad: botón "volver a realizar una tirada"
    try {
      const reThrowBtn = container.querySelector('[data-role="btn-re-throw"]') || container.querySelector('#btn-re-throw');
      if (reThrowBtn && !reThrowBtn.dataset.tkBound) {
        reThrowBtn.dataset.tkBound = '1';
        reThrowBtn.addEventListener('click', (ev) => {
          try { ev.preventDefault(); } catch (_) {}
          // Evitar dobles clics: desactivar el botón y marcar el primer clic
          try {
            if (reThrowBtn.dataset.tkClicked === '1') { return; }
            reThrowBtn.dataset.tkClicked = '1';
            reThrowBtn.setAttribute('disabled', 'disabled');
            reThrowBtn.setAttribute('aria-disabled', 'true');
            reThrowBtn.classList.add('is-disabled');
            reThrowBtn.style.pointerEvents = 'none';
          } catch (_) { /* noop */ }
          // 1) Desplazamiento suave hacia el título de esta instancia
          try {
            const preloaderEl = resolvePreloaderElement(container, cfg);
            if (preloaderEl && typeof preloaderEl.scrollIntoView === 'function') {
              preloaderEl.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            }
          } catch (_) { /* noop */ }
          // 2) Mostrar el loader de instancia del template (index.php ~110) y suprimir overlay global con retardo inicial
          try {
            const tktaLoaderClass = 'loader2';
            const { loaderBloq: instLoader, innerLoader } = ensureInstLoader(container, tktaLoaderClass);
            const delayShow = getLoaderInitialDelay(cfg);
            setTimeout(() => {
              try {
                if (instLoader) {
                  instLoader.classList.remove('is-hidden');
                  instLoader.dataset.suppressOverlay = '1';
                  instLoader.style.display = 'block';
                  instLoader.style.visibility = 'visible';
                  instLoader.style.opacity = '1';
                  try { void instLoader.offsetHeight; } catch (_) {}
                  try {
                    const spreadContainer = container.querySelector('.spread.tablero_container');
                    if (spreadContainer) { spreadContainer.style.opacity = '0.2'; }
                  } catch (_) { /* noop */ }
                  if (innerLoader && tktaLoaderClass) innerLoader.classList.add(String(tktaLoaderClass));
                  container.setAttribute('aria-busy', 'true');
                }
              } catch (_) { /* noop */ }
            }, Math.max(0, delayShow));
          } catch (_) { /* noop */ }
          // Marcar la instancia en sessionStorage para desplazar tras la recarga (sin modificar la URL)
          const idStr = String(cfg?.tarotId ?? '');
          try {
            const payload = {
              theme: 'tarokina',
              tarotId: idStr,
              path: `${window.location.pathname}${window.location.search}`,
              t: Date.now(),
            };
            window.sessionStorage.setItem('__tknaRethrow', JSON.stringify(payload));
          } catch (_) { /* noop */ }
          // Retardo sincronizado con el tiempo de visualización del loader en la espera AJAX (~3000ms)
          try {
            const tktaLoaderClass = 'loader2';
            const delayMs = getRethrowLoaderDuration(tktaLoaderClass, cfg);
            setTimeout(() => {
              try { window.location.reload(); }
              catch (_) { window.location.href = `${window.location.origin}${window.location.pathname}${window.location.search}`; }
            }, delayMs);
          } catch (_) { window.location.reload(); }
        });
      }
    } catch (e) {
      // Fallback silencioso si no puede enlazar el botón
    }

    // Listener de resize (una sola vez): re-ejecuta por cada instancia registrada
    if (!window.__tknaD1ResizeBound) {
      window.__tknaD1ResizeBound = true;
      window.addEventListener('resize', debounce(() => {
        try {
          const reg = ensureInstanceRegistry();
          reg.forEach((inst) => runModulesForInstance(inst));
        } catch (e) { /* noop */ }
      }, 200));
    }
  } catch (e) {
    console.error('[tarokina_d1] init error', e);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const theme = 'tarokina';
  const instances = (window.TkinaThemeData && window.TkinaThemeData[theme]) || [];
  if (Array.isArray(instances) && instances.length > 0) {
    instances.forEach((cfg) => {
      // Filtrar solo instancias del selector d1
      try {
        const sel = String(cfg?.themeOptions?.tkta_selector ?? 'd1').toLowerCase().trim();
        if (sel !== 'd1') { return; }
      } catch (_) { /* noop */ }
      try {
        const idStr = String(cfg?.tarotId ?? '');
        const container = Array.from(
          document.querySelectorAll(`.${theme}-theme[data-tkina-theme="${theme}"]`)
        ).find((el) => String(el.dataset.tarotId) === idStr);
        if (!container) {
          console.warn(`[${theme}] container not found for id`, idStr);
          return;
        }
        if (container.dataset.tkInited === '1') return;
        container.dataset.tkInited = '1';
        container.dataset.tkinaTheme = theme;
        container.dataset.tarotId = idStr;
        initTarokinaInstance(container, cfg);
      } catch (e) {
        console.error('[tarokina] Init error', e);
      }
    });
  } else {
    // Fallback si no hay datos inyectados desde PHP
    window.addEventListener('load', function() {
      // En ausencia de datos por instancia, ejecuta una sola vez como antes
      try { (initTablero.default || initTablero)(); } catch (_) {}
      try { (initSelector.default || initSelector)(); } catch (_) {}
      if (!window.__tknaD1ResizeBound) {
        window.__tknaD1ResizeBound = true;
        window.addEventListener('resize', debounce(() => {
          try { (initTablero.default || initTablero)(); } catch (_) {}
        }, 200));
      }
    });
  }

  // Tras la recarga, si existe marcador en sessionStorage, desplazar al título de la instancia correspondiente (sin hash)
  try {
    const raw = window.sessionStorage.getItem('__tknaRethrow');
    if (raw) {
      let data = null;
      try { data = JSON.parse(raw); } catch (_) { data = null; }
      const samePath = data && typeof data.path === 'string' && data.path === `${window.location.pathname}${window.location.search}`;
      const idStr = data && data.tarotId ? String(data.tarotId) : '';
      if (samePath && idStr) {
        // No volver a mostrar el loader tras la recarga para evitar duplicidades y bloqueo.
        // Si el usuario interactúa antes (scroll, clic, tecla, toque), cancelar el autoscroll.
        let cancelAutoScroll = false;
        const listeners = [];
        const cleanup = () => {
          try { listeners.forEach(({ t, h, o }) => window.removeEventListener(t, h, o)); } catch (_) {}
        };
        const cancel = () => { cancelAutoScroll = true; cleanup(); };
        try {
          const opts = { passive: true, capture: false };
          const add = (t) => { const h = cancel; window.addEventListener(t, h, { ...opts, once: true }); listeners.push({ t, h, o: { ...opts, once: true } }); };
          ['wheel','touchstart','keydown','mousedown','scroll'].forEach(add);
        } catch (_) {}

        const doScroll = () => {
          if (cancelAutoScroll) return; // respetar la intención del usuario
          try {
            const instContainer = Array.from(
              document.querySelectorAll(`.${theme}-theme[data-tkina-theme="${theme}"]`)
            ).find((el) => String(el.dataset.tarotId) === String(idStr));
            if (!instContainer) return;
            const preloaderEl = resolvePreloaderElement(instContainer, { tarotId: idStr });
            if (preloaderEl && typeof preloaderEl.scrollIntoView === 'function') {
              preloaderEl.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            }
            // Mantener coherencia: el loader de instancia se oculta cuando comience la interacción o cuando el módulo lo quite
          } catch (_) { /* noop */ }
          // Tras ejecutar el autoscroll, limpiar listeners
          cleanup();
        };
        // Esperar a que la instancia esté lista antes del scroll, con fallback por tiempo
        try {
          const instContainer = Array.from(
            document.querySelectorAll(`.${theme}-theme[data-tkina-theme="${theme}"]`)
          ).find((el) => String(el.dataset.tarotId) === String(idStr));
          if (instContainer) {
            waitForInstanceReady(instContainer, 2000).then(() => doScroll());
          } else {
            // Fallback: intentar pronto y al cargar
            try { requestAnimationFrame(() => doScroll()); } catch (_) { doScroll(); }
            try { window.addEventListener('load', () => doScroll(), { once: true }); } catch (_) {}
          }
        } catch (_) {
          try { requestAnimationFrame(() => doScroll()); } catch (_) { doScroll(); }
          try { window.addEventListener('load', () => doScroll(), { once: true }); } catch (_) {}
        }
      }
      // Limpiar siempre el marcador
      try { window.sessionStorage.removeItem('__tknaRethrow'); } catch (_) {}
    }
  } catch (_) { /* noop */ }
});